import { gsap, TimelineMax } from 'gsap';
export default {
  init() {

    $('#bio-overlay').hide();

      $('.close-overlay').on('click', function(e){
        e.preventDefault();
        $('#bio-overlay').fadeOut();
        $('.profile-photo', '.profile-name, .profile-job, .profile-bio').html(' ');
      });

      $('.member-info a').on('click', function(e){
        e.preventDefault();
        var photo = $(this).data('photo');
        var name = $(this).data('name');
        var job = $(this).data('job');
        var bio = $(this).data('bio');

        $('.profile-photo').html('<img src="' + photo + '" class="img-fluid" />');
        $('.profile-name').html(name);
        $('.profile-job').html(job);
        $('.profile-bio').html(bio);

        $('#bio-overlay').fadeIn();
      });
  },
  finalize() {}
}